<template>
	<div class="date-inputs">
		<label>
			Start:
			<input
				type="date"
				max="9999-12-31"
				required="true"
				class="form-control"
				:value="rangeStart"
				@input="$emit('update:rangeStart', $event.target.value)"
			>
		</label>
		<label>
			End:
			<input
				type="date"
				max="9999-12-31"
				required="true"
				class="form-control"
				:value="rangeEnd"
				@input="$emit('update:rangeEnd', $event.target.value)"
			>
		</label>
	</div>
</template>

<style scoped lang="scss">
.date-inputs {
	display: flex;
	gap: 1em;
	margin-bottom: 1em;

	&> label {
		display: flex;
		max-width: min-content;
		align-items: center;
		gap: 0.5em;
	}

	input[type="date"]:invalid {
		box-shadow: 0 0 2px 1px red;
	}
}
</style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		rangeStart: { type: String, required: true },
		rangeEnd: { type: String, required: true },
	},
});
</script>
